module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Preview":"Vorschau","Mobile":"Mobil","Tablet":"Tablet","Desktop":"Desktop","Dismiss":"Schließen","Clear cache":"Cache leeren","Cache cleared successfully":"Cache erfolgreich gelöscht","Cache could not be cleared":"Cache konnte nicht gelöscht werden","Preview could not be rendered":"Vorschau konnte nicht generiert werden"}}')
  delete Component.options._Ctor
}
